


















import {ObjectFactory} from '@/config/objectFactory';
import {MemberProfile} from '@/types/response';
import {Component, Vue} from 'vue-property-decorator';

@Component({})
export default class LeftNavigationBar extends Vue {
    private memberProfile: MemberProfile = ObjectFactory.getCacheService().getMemberInfo();

    private menuClick() {
        const element = document.getElementById('menuId');
        if (element) {
            element.classList.toggle('mystyle');
        }
    }
}
